import { render } from "./BaseViewHeaderSearch.vue?vue&type=template&id=935a65d4"
import script from "./BaseViewHeaderSearch.vue?vue&type=script&lang=js"
export * from "./BaseViewHeaderSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__